/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createContext } from 'react';

const initialContext = {
    showPassportEligibleFacet: false,
    trackPassportEligibleFacet: () => {},
};

const PassportFacetAbTestContext = createContext(initialContext);

export default PassportFacetAbTestContext;
